import { DefaultPrivacyLevel } from "@datadog/browser-rum";

export const environment = {
  production: false,
  version: 1,
  api: {
    base: "https://apim-np-t-idb-integration.iadb.org/ext/operations/luca-2/test/api/v1/",
    baseUpload: "https://apim-np-t-idb-integration.iadb.org/ext/operations/luca-ezshare-2/test/api/v1/",
    history: "efas/History",
    id : "1b774fbe-2def-4b51-94ee-97a7592caaab",
    subscriptionHeader: "Ocp-Apim-Subscription-Key",
    subscriptionKey: "711dcb05efc342d5960674fe323c5405",
    scope: 'api://1b774fbe-2def-4b51-94ee-97a7592caaab/api-access',
    idEzshare: '0e49143a-cf1d-4fc9-9fd1-f60e77f883c1',
    adminScope: 'Luca.Admin',
    adminRole: 'LUCA_Admins'
  },
  auth: {
    tenant: "9dfb1a05-5f1d-449a-8960-62abcb479e7d",
    clientId: "58a9e5b5-18c5-4658-8d87-008e235fc882",
    authority:
      "https://login.microsoftonline.com/9dfb1a05-5f1d-449a-8960-62abcb479e7d",
    redirectUri: "https://luca-test-2.iadb.org/",
    postLogoutRedirectUri: "https://luca-test-2.iadb.org/",
    endpoints: {
      "https://luca-test-2.iadb.org/":
      "f0031bdd-341e-456f-9d3e-ecb997d05556",
   },
  },
  dashboard: {
    kpi: 'https://app.powerbi.com/reportEmbed?reportId=24193532-d605-4a3d-ae32-18373676b0fd&autoAuth=true&ctid=9dfb1a05-5f1d-449a-8960-62abcb479e7d'
  },
  instrumentationKey: '8fbc036b-fc2c-4ff7-92f5-647d3c8eae23',
  datadog: {
      applicationId: '5241561d-4c06-4dd1-9a8a-fbaabcb2ffd0', 
      clientToken: 'pube37c7b17aa1e4835722931863f840366',
      env: 'test',
      sampleRate: 100,
      sessionReplaySampleRate: 100,
      enabled: false,
      defaultPrivacyLevel: DefaultPrivacyLevel.MASK_USER_INPUT,
      allowedTracingUrls: [/https:\/\/.*\.azurewebsites\.net/,/https:\/\/.*\.iadb\.org/],
      site: 'datadoghq.com',
      service: 'luca-dev-2',
      version: '14.5.0',
      trackInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      trackFrustrations: true,
      enableExperimentalFeatures: ['clickmap'],
    }
}; 
